import { CommonService } from '@services/common.service';
import { UserService } from '@services/user.service';
import { ErrorResponse } from '@models/error.response';
import {User, UserSearchingCriteria} from '@models/user';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { MainComponent } from '../main/main.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import { RoleService } from '@services/role.service';
import { Component, ViewChild, Input, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2'
import { switchMap } from 'rxjs/operators';
import { AdminUserService } from '@services/admin-user-service';
import { PageResponse } from "@models/page-response";
import { AdminUser } from "@models/admin-user";

declare var jQuery: any;

@Component({
    selector: 'user-change-workingdomain',
    templateUrl: './user-change-workingdomain.component.html',
    styleUrls: ['./user-change-workingdomain.component.scss']
})
export class UserChangeWorkingDomainComponent implements AfterViewInit {

    @ViewChild('modal', { static: false }) modal: ModalDirective;
    @ViewChild('form', { static: false }) form: NgForm;

    @Input() targetUser: User;

    isFieldError = FormValidationUtil.isFieldError;
    loading: boolean = false;
    workingDomainOptions: string[] = [];
    globalCriteria: string = '';
    searchingCriteria: UserSearchingCriteria = new UserSearchingCriteria();
    page: number = 1;
    size: number = 999999999;
    sortField: string;
    sortDirection: 'asc' | 'desc';

    formData: {
        workingDomain: string;
    }

    constructor(
        private roleService: RoleService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        public appConstant: AppConstant,
        public userService: UserService,
        private AdminUserService: AdminUserService,
        private commonService: CommonService) {
    }

    ngOnInit(): void {
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    return this.AdminUserService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection);
                })
            )
            .subscribe((res: PageResponse<AdminUser>) => {
                const stringSet: Set<string> = new Set<string>();
                res.content.forEach(item => {
                    var itemval = item.companyCode+(item.companyShortName?("."+item.companyShortName):"");
                    stringSet.add(itemval);
                })
                this.workingDomainOptions = Array.from(stringSet).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                console.log(this.workingDomainOptions);
            });

        this.loading = false;

        if(this.targetUser){
            this.formData = {
                workingDomain: this.targetUser.workingDomain
            }
        }else{
            this.formData = {
                workingDomain: ''
            }
        }

        if (this.form != null) {
            for (let key of Object.keys(this.form.controls)) {
                this.form.controls[key].markAsPristine();
            }
        }
    }

    ngAfterViewInit(): void {
    }

    public open(): void {
        this.ngOnInit();
        this.modal.show();
        // if(this.forceChangePassword){
        //     jQuery('#myModal').modal({backdrop: 'static', keyboard: false});
        // }
        // jQuery('#myModal').modal('show');
    }

    public close(): void {
        this.modal.hide();
        // jQuery('#myModal').modal('hide');
    }

    save() {
        //check form for just clicking save without any input
        for (let key of Object.keys(this.form.controls)) {
            this.form.controls[key].markAsDirty();
        }
        if (this.form.valid) {
            let instance = this;
            this.loading = true;
            this.mainComponent.enableLoadingMask();
                    var res = {'UPDATE_SUCCESS':'Update Success.',
                    'HAS_BEEN_UPDATED':'Message Had Been Updated.',
                    'UPDATE_FAIL': 'Fail to Update.',
                    'FAIL_TO_UPDATE': 'Message Fail to be Updated.'};
                    var pts = this.formData.workingDomain.split("\.");
                    this.formData.workingDomain = pts[0];
                    this.userService.switchDomain(this.formData.workingDomain, pts.length>1?pts[1]:"")
                            .subscribe(response => {
                                this.doUpdateBaseInfoSuccess(res, instance);
                            }, (error: ErrorResponse) => {
                                this.doUpdateBaseInfoFail(res, error, instance);
                            });
        }
    }

    doUpdateBaseInfoSuccess(res, instance): void {
        this.mainComponent.disableLoadingMask();
        this.targetUser.workingDomain = this.formData.workingDomain;
        
        this.doResetSessionUserIsForceChangePasswordStatus(this.targetUser);
        swal.fire({
            title: res.UPDATE_SUCCESS,
            text: res.HAS_BEEN_UPDATED,
            type: "success",
            allowEscapeKey: false,
            allowOutsideClick: false,
        }).then(function () {
            instance.loading = false;
            window.location.reload()
            // this.authService.logout();
            // this.router.navigate(['']);
            // instance.close();
        }).catch(() => {
            instance.loading = false;
            instance.close();
        });
    }

    doUpdateBaseInfoFail(res, error: ErrorResponse, instance): void {
        this.mainComponent.disableLoadingMask();

        instance.translate.get(error.errors[0].errorCode).subscribe(errorMsg => {
            swal.fire({
                title: res.UPDATE_FAIL,
                text: errorMsg,
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then(function () {
                instance.loading = false;
                // do nothing
            }).catch(() => {
                instance.loading = false;
            });
        });
    }

    doResetSessionUserIsForceChangePasswordStatus(user: User): void {
            this.commonService.setCurrentUser(user);
    }

    isConfirmPasswordMatch(): boolean {
        // if (this.formData != null
        //     && this.formData.confirmPassword != null && this.formData.confirmPassword !== ''
        //     && this.formData.password != null && this.formData.password !== '') {
        //     if (this.formData.confirmPassword !== this.formData.password) {
        //         return false;
        //     }
        // }
        return true;
    }

    isContainUsername(value): boolean {
        if (this.targetUser == null) {
            return false;
        }

        if (!value) {
            return false;
        }

        if (value.toLowerCase().indexOf(this.targetUser.username.toLowerCase()) !== -1) {
            return true;
        } else {
            return false;
        }
    }

    isInvalidPasswordComplexity(value): boolean {
        if (value == null || value.trim() == '') {
            return false;
        }

        return !(new RegExp(this.appConstant.passwordComplexityRegex).test(value));
    }

}